import React, { Component } from 'react';
import { Link } from 'react-router-dom';

import EventStatus from './event-status';
import TasksDue from './tasks-due';
import EventsToday from './events-today';
import CostBreakdown from './cost-breakdown';
import moment from 'moment';
import Loading from '../ui/loading-spinner';

class Dashboard extends Component {
    componentDidMount() {
        let userInfoCode = '';
        let billetLocation = this.props.userInfo.Billet.location;
        if (billetLocation === 'RSS' && !!this.props.userInfo.RSS) {
            userInfoCode =
                '&filters[Event][recruitingSubStationCode][eq]=' +
                this.props.userInfo.RSS.code;
        } else if (billetLocation === 'OSS') {
            userInfoCode =
                '&filters[Event][ossCode][eq]=' +
                this.props.userInfo.OSS.ossNumber;
        } else if (billetLocation === 'RS') {
            userInfoCode =
                '&filters[Event][recruitingStationCode][eq]=' +
                this.props.userInfo.RS.code;
        } else if (billetLocation === 'District') {
            userInfoCode =
                '&filters[Event][districtCode][eq]=' +
                this.props.userInfo.District.code;
        } else if (billetLocation === 'Region') {
            userInfoCode =
                '&filters[Event][regionCode][eq]=' +
                this.props.userInfo.District.Region.code;
        }

        this.props.fetchDashboardETResults(
            '&fields[EventReport][]=status' + userInfoCode,
            'eventstoday'
        );
        this.props.fetchDashboardCostsResults('fields[Event][]=cost');

        this.props.eventStatusBreakdownThunk();
        this.props.taskDueThunk();
    }
    render() {
        return (
            <div className="dashboard">
                <div className="dashboard__event-date clearfix">
                    <span className="dashboard__date">
                        {moment().format('MMMM D')}
                    </span>
                    <span className="dashboard__year">
                        {moment().format('YYYY')}
                    </span>
                </div>
                <div className="dashboard__container">
                    <Link to="/reporting" className="dashboard__entry">
                        {this.props.getEventStatusBreakDown.isLoading ? (
                            <Loading />
                        ) : (
                            <EventStatus
                                eventStatusBreakDown={
                                    this.props.getEventStatusBreakDown
                                }
                            />
                        )}
                    </Link>

                    <Link to="/alerts" className="dashboard__entry">
                        {this.props.getTasksDueLoading ? (
                            <Loading />
                        ) : (
                            <TasksDue data={this.props.getTasksDueTotal} />
                        )}
                    </Link>

                    <Link to="/calendar" className="dashboard__entry">
                        <EventsToday
                            data={this.props.dashboardETResultsNumber}
                        />
                    </Link>

                    <Link to="/reporting" className="dashboard__entry">
                        <CostBreakdown feed={this.props.dashboardCosts} />
                    </Link>
                </div>
            </div>
        );
    }
}

export default Dashboard;



// WEBPACK FOOTER //
// ./src/components/dashboard/index.js